var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Prices might change if a service was updated after creating an appointment.
 * This function ensures that the prices of the services are the same
 * as the ones present at the time of the appointment creation.
 */
export var withServicePricesFromAppointment = function (services, appointment) {
    var apptServices = (appointment === null || appointment === void 0 ? void 0 : appointment.appointment_service) || [];
    var apptServicesById = apptServices.reduce(function (memo, apptService) {
        var _a;
        return __assign(__assign({}, memo), (_a = {}, _a[apptService.service.id] = apptService, _a));
    }, {});
    return services.map(function (service) {
        var serviceFromAppt = apptServicesById[service.id];
        if (serviceFromAppt) {
            return __assign(__assign({}, service), { cost: serviceFromAppt.cost, costWithTaxes: serviceFromAppt.costWithoutTaxes + serviceFromAppt.taxAmount, costWithoutTaxes: serviceFromAppt.costWithoutTaxes, taxAmount: serviceFromAppt.taxAmount });
        }
        return service;
    });
};
